// src/hooks/useValidation.js

import { useState } from "react";
import {
  validateChallengeFields,
  getSnackbarErrorMessage,
} from "../utils/validation"; 

const useValidation = () => {
  const [errors, setErrors] = useState({});

  const validate = (formData, requireHero = false) => {
    const fieldErrors = validateChallengeFields(formData);

    // If publishing, ensure a cover image is present
    if (requireHero && !formData.hero) {
      fieldErrors.hero = "Cover image is required for publishing.";
    }

    setErrors(fieldErrors); // Update state with the latest errors
    return fieldErrors; // Return the errors directly
  };

  const getErrorMessage = (fieldErrors) => {
    // Use the provided fieldErrors instead of the state
    return getSnackbarErrorMessage(fieldErrors);
  };

  const clearErrors = () => {
    setErrors({});
  };

  return {
    errors,
    validate,
    getErrorMessage,
    clearErrors,
  };
};

export default useValidation;
